import styled, { css, keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

interface modalParams {
	visible: boolean;
}

export const Container = styled.div<modalParams>`
	flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 200vw;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 7;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;
	transition: opacity 0.5s ease-in-out;
	opacity: 0;

	${props =>
		props.visible &&
		css`
			opacity: 1;
		`
	}

  .active {
    opacity: 1;
    top: 15%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }
`;

export const Content = styled.div`
	display: flex;
  flex-direction: column;
  background: #fff;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
	width: 52%;
	height: 75%;
  border-radius: 5px;
  padding: 20px;
  visibility: hidden;
  transition: all 0.5s ease-out;

	// 767px
  @media (max-width: 47.9375rem) {
    width: 80%;
  };
	// 479px
  @media (max-width: 29.9375rem) {
		width: 95%;
		padding: 10px
  };
`;

export const FormView = styled(Form)`
  display: block;
  flex-direction: column;

  .input-content {
    display: flex;
		flex-direction: column;
    margin-bottom: 10px;

    .input {
      display: flex;
			flex-direction: column;

      span {
        font-size: 16px;
        font-weight: 500;
				padding-left: 5px
      }
    }
  }

  .buttons {
    display: flex;

    button:first-child {
      margin-right: 10px;
    }
  }
`;

export const FormAddAponta = styled(Form)`
	display: flex;
	// 479px
  @media (max-width: 29rem) {
		width: 80%;

		input {
			max-width: 170px;
		}
  };
`;

export const ListApontamentos = styled.div`
	display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;
  list-style: none;
	max-height: 43%;
	min-height: 10%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 10px 2px 25px 2px;
  padding: 15px 10px;

	overflow-y: scroll;
`;

export const ItemApontamento = styled.div`
	display: flex;
	align-items: center;
	padding: 5px 0;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
`;

export const ModalHeader =styled.div`
	display: flex;
	width: 100%;
	padding: 5px 0 20px 2px;

	h1 {
		font-size: 1.2rem;
		font-weight: 500;
	}
`;

export const ModalFooter = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	// border: 1px solid red;
`;
